const Home = () => {
  return (
    <div id="home" className="home">
      <div className="container-fluid">
        <div>
          <div className="text-white" data-aos="fade-down-right" data-aos-duration="2000">
            자동화 소프트웨어의 선두주자
          </div>
          <div className="text-white" data-aos="fade-up-left" data-aos-duration="2000">
            (주)아미소프트
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
